/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The props for `<MaterialIcon />`.
 * @export
 * @interface MaterialIconProps
 */
export interface MaterialIconProps {
  /**
   * Color for material icon.
   * @type {string}
   * @memberof MaterialIconProps
   */
  color?: string;

  /**
   * Name of material icon.
   * @type {string}
   * @memberof MaterialIconProps
   */
  name?: string;
}

/**
 * The default prop values for `<MaterialIcon />`.
 * @export
 */
export const materialIconDefaults = {
  color: 'teal',
  name: 'widgets',
};
